// Per-quiz write tokens (2026-09-25).
//
// The backend issues a secret `write_token` when this browser creates a quiz. Anonymous
// writes to that quiz (answers, info, priorities, exercises, the contact lead) must send
// it back as X-Quiz-Token, so nobody else can tamper with an unclaimed quiz by guessing
// its sequential id. The HTTP client attaches it automatically (providers/ht.ts).

const STORAGE_KEY = "mp_quiz_write_tokens";
const KEEP = 20;

type TokenMap = Record<string, string>;

const read = (): TokenMap => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

export const saveQuizToken = (quizId: number | string, token: string | undefined | null) => {
  if (!token || quizId === undefined || quizId === null) return;
  try {
    const map = read();
    delete map[String(quizId)];
    map[String(quizId)] = token;
    const keys = Object.keys(map);
    for (const k of keys.slice(0, Math.max(0, keys.length - KEEP))) delete map[k];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Storage unavailable (private mode): writes fall back to the backend's rules.
  }
};

export const getQuizToken = (quizId: number | string | undefined | null): string | undefined => {
  if (quizId === undefined || quizId === null || quizId === "") return undefined;
  return read()[String(quizId)];
};

// Which quiz a request targets: the id in a quiz-keyed URL, or the `quiz` field of a
// lead being created.
const QUIZ_URL = /\/(?:quizzes|leads\/quiz|exercises\/quiz)\/(\d+)(?:\/|$|\?)/;

export const quizIdForRequest = (url: string | undefined, method: string | undefined, data: unknown) => {
  const m = QUIZ_URL.exec(url || "");
  if (m) return m[1];
  if ((method || "").toLowerCase() === "post" && /^\/?leads\/?(\?|$)/.test(url || "")) {
    let body: any = data;
    if (typeof body === "string") {
      try {
        body = JSON.parse(body);
      } catch {
        return undefined;
      }
    }
    return body && body.quiz != null ? String(body.quiz) : undefined;
  }
  return undefined;
};
